import styled from "styled-components";
import { ReactComponent as VoteAgainIcon } from "src/images/voteAgainIcon.svg";
import { ReactComponent as EditIcon } from "src/images/editTaskIcon.svg";
import { ReactComponent as DeleteIcon } from "src/images/deleteTaskIcon.svg";
import { ReactComponent as CloseIcon } from "src/images/taskCloseListIcon.svg";
import { scrollbar } from "src/styles/mixins";
import ConfirmationPopup from "src/components/shared/ConfirmationPopup";

export const TaskContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const TaskListItemUpperRowWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
  flex: 1;
`;

export const TaskListItemBottomRowWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
  flex: 1;
  margin-top: 10px;
`;

export const TitleLabel = styled.p`
  line-height: ${({ theme }) => theme.fonts.lineHeights.xs};
  font-size: ${({ theme }) => theme.fonts.sizes.xxs};
  font-weight: ${({ theme }) => theme.fonts.weights.normal};
  color: ${({ theme }) => theme.colors.primary};

  margin-right: 68px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const TaskTitleTextArea = styled.textarea`
  border: none;
  flex: 1;
  text-align: flex-start;
  outline: none;

  font-size: ${({ theme }) => theme.fonts.sizes.xxs};
  line-height: ${({ theme }) => theme.fonts.lineHeights.xxxs};
  font-weight: ${({ theme }) => theme.fonts.weights.medium};
  color: ${({ theme }) => theme.colors.primary};

  ${scrollbar}
`;

export const TaskButtonsWrapper = styled.div<{ isVisible: boolean }>`
  display: flex;
  visibility: ${({ isVisible }) => (isVisible ? "visible" : "hidden")};
  flex-direction: row;
  justify-self: flex-end;
`;

export const EditTaskIcon = styled(EditIcon)`
  margin-right: 18px;

  :hover {
    cursor: pointer;
  }
`;

export const DeleteTaskIcon = styled(DeleteIcon)`
  :hover {
    cursor: pointer;
  }
`;

export const ResultLabel = styled.p`
  line-height: ${({ theme }) => theme.fonts.lineHeights.xs};
  font-size: ${({ theme }) => theme.fonts.sizes.xxs};
  font-weight: ${({ theme }) => theme.fonts.weights.normal};
  color: ${({ theme }) => theme.colors.gray};

  margin-right: 14px;
`;

export const VoteAgainWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  height: fit-content;
  width: fit-content;

  :hover {
    cursor: pointer;
  }
`;

export const RepeatVoteIcon = styled(VoteAgainIcon)`
  margin-right: 10px;
`;

export const RepeatVoteLabel = styled.p`
  line-height: ${({ theme }) => theme.fonts.lineHeights.xs};
  font-size: ${({ theme }) => theme.fonts.sizes.xxs};
  font-weight: ${({ theme }) => theme.fonts.weights.normal};
  color: ${({ theme }) => theme.colors.primary};
`;

export const VoteTaskButton = styled.p`
  line-height: ${({ theme }) => theme.fonts.lineHeights.xs};
  font-size: ${({ theme }) => theme.fonts.sizes.xxs};
  font-weight: ${({ theme }) => theme.fonts.weights.normal};
  color: ${({ theme }) => theme.colors.primary};

  :hover {
    cursor: pointer;
  }
`;

export const CurrentlyVotingLabel = styled.p`
  line-height: ${({ theme }) => theme.fonts.lineHeights.xs};
  font-size: ${({ theme }) => theme.fonts.sizes.xxs};
  font-weight: ${({ theme }) => theme.fonts.weights.normal};
  color: ${({ theme }) => theme.colors.primary};
`;

export const ResultContentWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const ResultContent = styled.div<{ wasVoted: boolean }>`
  background-color: ${({ theme, wasVoted }) =>
    wasVoted ? theme.colors.buttonPrimary : theme.colors.gray};
  border: ${({ theme }) =>
    `${theme.border.thin} solid ${theme.colors.primary}`};
  border-radius: ${({ theme }) => `${theme.borderRadius.s}`};

  width: 29px;
  height: 48px;
  display: grid;
  place-items: center;
`;

export const ResultContentValue = styled.p`
  line-height: ${({ theme }) => theme.fonts.lineHeights.xs};
  font-size: ${({ theme }) => theme.fonts.sizes.xxs};
  font-weight: ${({ theme }) => theme.fonts.weights.normal};
  color: ${({ theme }) => theme.colors.primary};
`;

export const TaskCloseListIcon = styled(CloseIcon)`
  margin-top: 21px;
  justify-self: flex-end;

  :hover {
    cursor: pointer;
  }
`;

export const DeleteTaskConfirmationPopup = styled(ConfirmationPopup)`
  top: 53px;
  left: 50%;
  transform: translateX(-50%);
  width: 296px;

  p {
    margin-top: 0;
  }
`;
